import React from 'react';
import { Image } from '@sparefoot/react-core';
import { H2, Paragraph } from 'components/core/Typography';

import swervy from 'assets/images/layout/wave-background-bottom-dark-blue-extended.svg';
import filter from 'assets/images/plp/plp-filter.svg';
import location from 'assets/images/plp/plp-location.svg';
import noCost from 'assets/images/plp/plp-no-cost.svg';
import online from 'assets/images/plp/plp-online.svg';
import pricing from 'assets/images/plp/plp-pricing.svg';
import storageUnit from 'assets/images/plp/plp-unit.svg';
import vanLogo from 'assets/images/plp/plp-van-logo.svg';

import Container from '../../core/Page/Container';

import './HowItWorksSection.scss';

const howItWorksCards = [
	{
		icon: location,
		text: 'Enter your location to find storage units near you.',
	},
	{
		icon: filter,
		text: 'Filter by price, size, climate control, and more to find your perfect match.',
	},
	{
		icon: pricing,
		text: 'Shop smart by comparing units, pricing, and reviews.',
	},
	{
		icon: noCost,
		text: 'Book instantly with the click of a button. No credit card needed.',
	},
	{
		icon: online,
		text: 'Complete your rental by signing your lease online or in person.',
	},
	{
		icon: storageUnit,
		text: 'Move into your storage unit and enjoy your extra space.',
	},
];

const HowItWorksSection = () => {
	return (
		<section
			className="how-it-works-container"
			id="how-it-works"
		>
			<Container>
				<div className="content-container">
					<div className="header-image-container">
						<Image
							src={vanLogo}
							alt="moving"
							width="250"
							height="201"
						/>
						<H2 size="large">How It Works</H2>
					</div>

					<div className="cards-container">
						{howItWorksCards.map((card) => (
							<div
								className="info-card"
								key={card.text}
							>
								<Image
									src={card.icon}
									alt={card.text}
									width={64}
									height={64}
								/>
								<Paragraph>{card.text}</Paragraph>
							</div>
						))}
					</div>
				</div>
			</Container>
			<Image
				src={swervy}
				role="presentation"
				className="swervy"
			/>
		</section>
	);
};

export default HowItWorksSection;
